import React, { FC, useContext, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MenuItem } from "react-pro-sidebar";
import { matchPath } from "react-router";
import { Link } from "react-router-dom";
import { ICustomPopoverTrigger } from "../sidebar.types";
import { IClicked } from "./../index";
import SystemContext from "../../../../context/systemContext";
import { PopoverStyled } from "../aside.style";
import Tooltip from "../../../../components/toltip/Tooltip";

export const CustomPopoverTrigger: FC<ICustomPopoverTrigger> = ({
  history,
  item,
  hasAccess,
  popover,
  collapse,
  clicked,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { orgSettings } = useContext<any>(SystemContext);

  const popoverChildren = item?.children?.map((child: any, index: number) => {
    if (item.showKey === "course" && !orgSettings[child?.showKey]) {
      return null;
    }

    return (
      hasAccess(child.id) && (
        <React.Fragment key={index}>
          {!item?.multi && (
            <MenuItem
              key={index.toString()}
              onClick={(e) => {
                e.preventDefault();
                if (history.location.pathname !== child.path) {
                  history.push(child.path);
                  clicked({ name: child.title, url: child.path });
                }
              }}
              active={
                history.location.pathname === child.path ||
                !!child?.child?.find(
                  (path: string) =>
                    matchPath(history.location.pathname, path)?.isExact
                )
              }
              className={`text-black`}
            >
              <li
                className={`list-item ${
                  history.location.pathname === child.path && "selected-menu"
                }`}
              >
                {t([`NAVIGATOR.${child.title}`])}
              </li>
            </MenuItem>
          )}
        </React.Fragment>
      )
    );
  });

  const multiPoppover = item.multi && (
    <PopoverStyled
      id="popover-basic-multi"
      style={{ display: "flex", gap: "10px" }}
    >
      {item.children?.map(
        (value: any) =>
          value.id?.find((val: string) => hasAccess(val)) && (
            <div className="multiPoppoverContents">
              <Popover.Header className="poppoverHeader" as="p">
                {t(`NAVIGATOR.${value.title}`)}
              </Popover.Header>
              <Popover.Body style={{ padding: "2px 12px" }}>
                {value?.children?.map(
                  (val: any, index: number) =>
                    hasAccess(val.id) && (
                      <MenuItem
                        key={index.toString()}
                        onClick={(e) => {
                          e.preventDefault();
                          if (history.location.pathname !== val.path) {
                            history.push(val.path);
                            clicked({ name: val.title, url: val.path });
                          }
                        }}
                        active={
                          history.location.pathname === val.path ||
                          !!val?.child?.find(
                            (path: string) =>
                              matchPath(history.location.pathname, path)
                                ?.isExact
                          )
                        }
                        className={`text-black`}
                      >
                        {t([`NAVIGATOR.${val.title}`]).length > 26 ? (
                          <Tooltip
                            message={t([`NAVIGATOR.${val.title}`])}
                            placement="top"
                          >
                            <li
                              className={`list-item ${
                                history.location.pathname === val.path &&
                                "selected-menu"
                              }`}
                            >
                              {t([`NAVIGATOR.${val.title}`])}
                            </li>
                          </Tooltip>
                        ) : (
                          <li
                            className={`list-item ${
                              history.location.pathname === val.path &&
                              "selected-menu"
                            }`}
                          >
                            {t([`NAVIGATOR.${val.title}`])}
                          </li>
                        )}
                      </MenuItem>
                    )
                )}
              </Popover.Body>
            </div>
          )
      )}
    </PopoverStyled>
  );

  return (
    <div
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      key={item.id}
      className="custom-menu"
    >
      <OverlayTrigger
        trigger={"click"}
        placement="right-start"
        show={show}
        overlay={item.multi ? multiPoppover : popover("", popoverChildren)}
        rootClose={true}
      >
        <div
          onClick={() => {}}
          className={`text-black custom-menu-item ${
            !!item.children?.find(
              (child: any) => history.location.pathname === child.path
            ) ||
            item.children?.find((child: any) =>
              child.child?.find(
                (childPaths: string) =>
                  matchPath(history.location.pathname, childPaths)?.isExact
              )
            ) ||
            item.children?.find((child: any) =>
              child.children?.find(
                (childPaths: any) =>
                  matchPath(history.location.pathname, childPaths?.path)
                    ?.isExact
              )
            ) ||
            show
              ? "openMenu"
              : ""
          }`}
        >
          <span className="icon">{item.icon}</span>
          <span>{collapse && t([`NAVIGATOR.${item.title}`])}</span>
          <div>{!collapse && t([`NAVIGATOR.${item.title}`])}</div>
        </div>
      </OverlayTrigger>
    </div>
  );
};
